import { createSlice } from '@reduxjs/toolkit';

import eventBus from '@utils/eventBus';
import { EventType } from '@utils/eventBus/eventTypes';

import { handleRemoveSupplementFromInquiryDraft } from './actions';
import { IRemoveSupplementFromInquiryDraftState } from './slice.interface';

const initialState: IRemoveSupplementFromInquiryDraftState = {
  isLoading: false,
};

export const removeSupplementFromInquiryDraftSlice = createSlice({
  name: 'remove-supplement-from-inquiry-draft',
  initialState,
  reducers: {
    removeDeleteSupplementFromInquiryDraft: state => {
      state.isLoading = false;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(
        handleRemoveSupplementFromInquiryDraft.pending,
        (state: IRemoveSupplementFromInquiryDraftState) => {
          state.isLoading = true;
        },
      )
      .addCase(
        handleRemoveSupplementFromInquiryDraft.fulfilled,
        (state: IRemoveSupplementFromInquiryDraftState) => {
          state.isLoading = false;
          eventBus.emit(EventType.REMOVE_SUPPLEMENT_FROM_INQUIRY_DRAFT_SUCCESS);
        },
      );
  },
});

export const { removeDeleteSupplementFromInquiryDraft } =
  removeSupplementFromInquiryDraftSlice.actions;

export default removeSupplementFromInquiryDraftSlice.reducer;
